import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'loyaltic-scratch-card',
    templateUrl: './scratch-card.component.html',
    styleUrls: ['./scratch-card.component.scss'],
    standalone: false
})
export class ScratchCardComponent implements OnInit {
  cardWinImage = 'https://res.cloudinary.com/lojaali/image/upload/v1641991785/SWECHIPSVAL22/logo-estrella.png';
  constructor() {

   }

  ngOnInit() {
    this.scratchCard();
  }

  scratchCard(){

  }

}
